let config = {
  Navigation: {
    homePage: '首页',
    ComplaintInquiry: '投诉查询'
  },
  complaintForm: {
    title1: ' 地区声明 ',
    title2: ' 投诉人信息 ',
    title3: ' 事件投诉 ',
    title4: ' 投诉确认',
    located: '投诉人所在国家/城市',
    misconductOccur: '被投诉事件发生国家/城市',
    nextStep: '下一步',
    type: '投诉类型',
    pleaseSelect: '请选择',
    pleaseSelectTimes: '请选择时间',
    eventTime: '被投诉事件发生时间',
    times: '被投诉事件发生次数',
    frequency: '被投诉事件发生频率',
    continueFlag: '被投诉事件是否仍在持续',
    continueFlagSelect: {
      yes: '是',
      no: '否'
    },
    eventPlayers: '被投诉事件参与人',
    eventPlayersForms: {
      userName: '姓名',
      department: '所在机构',
      position: '职位',
      managerFlag: '是否为高管',
      operation: '操作',
      delete: '删除',
      handleAddParticipant: '添加参与人'
    },
    desInformation: '被投诉事件详细描述',
    speechCompanyFlagFlag: '您是否曾向公司管理层或有关部门上报此事？',
    speechOtherFlagFlag: '您是否曾向其他外部机构上报此事？',
    speechCompanyFlag: '向公司管理层或有关部门上报的详细信息',
    speechOtherFlag: '向其他外部机构上报的详细信息',
    aboutOtherFlag: '被投诉事件是否涉及外部组织/机构',
    aboutOtherFlagSelect: {
      yes: '是',
      no: '否',
      unKnown: '不知情'
    },
    otherDepartment: '外部组织/机构名称',
    witnessName: '被投诉事件有无其他证明人？如果有，请您指出',
    witnessNameSelect: {
      yes: '有',
      no: '无',
      disclose: '不愿透露'
    },
    howToKnow: '您是如何知晓此事件的',
    howToKnowSelect: {
      victim: '受害人',
      participant: '参与者',
      witness: '见证人',
      overhearing: '无意听到',
      rumours: '传言',
      disclose: '不愿透露'
    },
    authenticatorList: '被投诉事件证明人',
    authenticatorListTable: {
      userName: '姓名',
      department: '所在机构',
      position: '职位',
      operation: '操作',
      delete: '删除',
      handleAddWitness: '添加证明人'
    },
    sysFiles: '上传附件',
    uploadTip1: '上传附件，请在此上传任何您认为与本次投诉事件相关的支持性文件，包括音频、视频、照片、文档等。',
    uploadTip2: '只能上传50mb以下的文件，若要上传50mb以上文件，请联系管理员：',
    uploadTip3: '如有文件上传，请发送至',
    uploadButton: '点击上传',
    previousStep: '上一步',
    submitForm: '提交',
    desInformationPlaceholder: '请您填写投诉事件内容，并描述清楚在哪里发生、发生了什么、事件涉及金额（如知晓）。您认为违反了哪些条款或规定。\n示例：2016年10月13日下午，我发现张三在装卸码头偷了一台新电脑，违反了员工守则。',
    speechOtherFlagPlaceholder: '请您填写什么时间上报？以什么形式上报？上报机构？\n示例：2016年12月3日，我通过公开举报信箱将此事上报至XX市信访办。',
    speechCompanyFlagPlaceholder: '请您填写什么时间上报、以什么形式上报、上报机构及部门、上报对象职位或姓名。\n示例：2017年4月7日，我通过邮件的形式告知了XX公司XX部部长。',
    content: '时区为东八区',
    complainTypeList: {
      type1: '员工权益',
      type2: '安全健康环保',
      type3: '利益冲突与内幕交易',
      type4: '贪腐舞弊与洗钱',
      type5: '资产使用与保护',
      type6: '信息安全与个人隐私保护',
      type7: '财务报告、税收和公开信息披露',
      type8: '垄断',
      type9: '贸易合规',
      type10: '公平交易和公平竞争',
    }
  },
  statementText: {
    warning: '注意',
    warningContent: '请确保您已经保存报告编号和识别密码',
    warningButton1: '取消',
    warningButton2: '确认',
    statementTitle: '中国海洋石油有限公司合规投诉信息收集 | 投诉人信息 | 事件投诉',
    stepActionText0: '中国海洋石油有限公司通过合规投诉渠道为任何人提供上报不当行为、可能违反《合规手册》或其他公司制度的行为，以及涉嫌违反法律法规的行为。| 请注意：本合规投诉渠道并非紧急事件受理，请不要使用此渠道投诉对生命或财产直接构成威胁的事件。通过此渠道提交的投诉可能不会立即得到答复，如果您需要紧急协助，请与当地机构联系。',
    stepActionText1: '除非国家/地区法规禁止匿名，否则您有权选择匿名投诉。请您谨慎地告知您的身份等隐私信息，我们也保证您的隐私信息将被视为机密信息。| 大多数情况下，同一投诉事件的调查核实需要多次深入交流，留下您的联系方式有助于事件的调查处理。同时，了解您的身份也有助于我们保护您免受任何打击报复的风险。| 再次强调：您有权选择匿名投诉。',
    stepActionText2: '您提供的信息将得到严格保密，只有负责进一步审核报告的人员方可查阅。| 您报告的信息可能会导致内部调查和公共机关调查。鉴于此，请只提供您所知的真实准确的信息。| 您报告的信息对于被投诉事件问题的调研核实起着重要的作用，为提高调研效率降低交流难度，请您在保证真实准确的前提下，提供尽可能详尽的描述信息，并提供您认为必要的证明性材料。',
    statementChecked: '我已详细阅读以上声明信息',
    statementButton: '我已阅读'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  settings: {
    title: '系统布局配置',
    theme: '主题色',
    tagsView: '开启 Tags-View',
    fixedHeader: '固定 Header',
    sidebarLogo: '侧边栏 Logo'
  },
  relation: {
    question: '您与中国海洋石油有限公司的关系 | 是否愿意留下您的联系方式方便我们进一步跟进您的投诉事件？ | 是否需要匿名举报？',
    limiteds: {
      value1: '员工',
      value2: '合作商',
      value3: '不透露',
      value4: '其他（请明确）'
    },
    limitedOther: '所在部门 | 关系明确信息',
    select: '是 | 否',
    choose: '请选择',
    telephone: '联系电话',
    email: '邮箱',
    complainName: '姓名',
    complainantRules: {
      limited: '请选择您与中海油的关系',
      department: '请填写您的所在部门',
      limitedText: '请明确您与中海油的关系',
      contactInformationFlag: '请选择您是否愿意留下您的联系方式方便我们进一步跟进您的投诉事件',
      complainName: '请填写您的姓名',
      anonymousFlag: '请选择您是否需要匿名举报',
      departmentLimit: '输入内容长度最大为510个字符',
      limitedTextLimit: '输入内容长度最大为510个字符',
      telephoneLimit: '输入内容长度最大为510个字符',
      emailLimit: '输入内容长度最大为510个字符',
      complainNameLimit: '输入内容长度最大为510个字符'
    },
    regionRules: {
      located: '请填写投诉人所在国家/城市',
      misconductOccur: '请填写被投诉事件发生国家/城市',
      locatedLimit: '输入内容长度最大为510个字符',
      misconductOccurLimit: '输入内容长度最大为510个字符'
    },
    complaintRules: {
      type: '请选择投诉类型',
      eventTime: '请填写被投诉事件发生时间',
      times: '请填写被投诉事件发生次数',
      frequency: '请填写被投诉事件发生频率',
      continueFlag: '请选择被投诉事件是否仍在持续',
      eventPlayers: {
        Error: '请添加被投诉事件参与人',
        userName: '请填写被投诉事件参与人姓名',
        department: '请填写被投诉事件参与人所在机构',
        position: '请填写被投诉事件参与人职位',
        managerFlag: '请选择被投诉事件参与人是否为高管',
        userNameLimit: '输入内容长度最大为510个字符',
        departmentLimit: '输入内容长度最大为510个字符',
        positionLimit: '输入内容长度最大为510个字符'
      },
      authenticatorList: {
        Error: '请添加被投诉事件证明人',
        userName: '请填写被投诉事件证明人姓名',
        department: '请填写被投诉事件证明人所在机构',
        position: '请填写被投诉事件证明人职位',
        userNameLimit: '输入内容长度最大为510个字符',
        departmentLimit: '输入内容长度最大为510个字符',
        positionLimit: '输入内容长度最大为510个字符'
      },
      desInformation: '请填写被投诉事件详细描述',
      speechCompanyFlagFlag: '请选择您是否曾向公司管理层或有关部门上报此事',
      speechCompanyFlag: '请填写您向公司管理层或有关部门上报的详细信息',
      speechOtherFlagFlag: '请选择您是否曾向其他外部机构上报此事',
      speechOtherFlag: '请填写您向其他外部机构上报的详细信息',
      aboutOtherFlag: '请选择被投诉事件是否涉及外部组织/机构',
      otherDepartment: '请填写外部组织/机构名称',
      witnessName: '请选择被投诉事件有无其他证明人',
      howToKnow: '请选择您是如何知晓此事件的',
      timesLimit: '输入内容长度最大为510个字符',
      frequencyLimit: '输入内容长度最大为510个字符',
      otherDepartmentLimit: '输入内容长度最大为510个字符'
    },
    emailError: '邮箱格式如:admin@163.com',
    button: '上一步 | 下一步'
  },
  complaintConfirmation: {
    complaint: '感谢您的主动投诉，我们已向中国海油石油有限公司指定部门提交您的报告并将开展核实调研。您的报告将得到保密处理。本报告已自动生成唯一的报告编号和识别密码，该报告编号和密码是对投诉事件的跟进凭据，请妥善保存。',
    number: '报告编号：',
    password: '识别密码：',
    help1: '出于数据保护的原因，公司仅提供投诉事件调研处理的进度反馈，而无法告知您调查结果的详细情况，或可能产生的任何影响。',
    help2: '您可于此后返回本网站查看投诉的处理进度，届时将会要求您提供报告编号与识别密码。'
  },
  // history
  // 投诉查询条件
  searchRules: {
    formId: '报告编号',
    formIdPH: '请输入您的报告编号',
    formIdMsg: '报告编号不能为空',
    formKey: '识别密码',
    formKeyPH: '请输入您的识别密码',
    formKeyMsg: '识别密码不能为空',
    searchBtn: '查询',
    resetBtn: '重置'
  },
  complaintDetail: {
    viewDetailBtn: '查看详情',
    detailTitle: '投诉信息 | 投诉反馈',
    statusMap: '未处理 | 处理中 | 已完成',
    msg: '投诉已接收，请您等待处理',
    msg1: '您的投诉已受理，正在处理中',
    located: '投诉人所在国家/城市',
    misconductOccur: '被投诉事件发生国家/城市',
    limited: '您与中海油的关系',
    department: '所在机构',
    complainTitle: '投诉标题',
    submitTime: '提交时间',
    frequency: '被投诉事件发生频率',
    times: '被投诉事件发生次数',
    complainName: '举报人名称',
    eventPlayersForms: {
      managerFlag: '是否高管'
    },
    authenticatorListTable: {
      userName: '姓名',
      department: '所在机构',
      position: '职位'
    },
    file: '反馈附件'
  },
  msg: {
    msg1: '报告编号或者识别密码错误',
    msg2: '查询成功',
    msg3: '查询失败',
    msg4: '上传失败',
    msg5: '最多上传10个文件',
    msg6: '投诉成功',
    msg7: '验证码过期,请刷新',
    msg8: '验证不通过',
    msg9: '按住滑块，拖动完成上方拼图',
    msg10: '设置语言成功',
    msg11: '文件大小不能超过50mb',
    msg12: '只能上传文件类型为jpg、png、gif、mp4、flv、wmv、avi、mkv、txt、xlsx、xls、vsdx、docx、doc、ppt、pptx的文件'
  }

}
if (process.env.VUE_APP_DESENSITIZATION) {
  config = JSON.parse(JSON.stringify(config).replace(/中国海洋石油有限公司|cnooc|中国海油|中海油|中国海洋石油|有限公司/gi,'x公司'))
}

export default config
